import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged, map, pairwise } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { PricebookCompartments, pricebookStorageKey } from '..';
import { GroupCompartments, groupStorageKey } from '../../group';
import { GroupData } from '../../../models/GroupData';

export class PricebookOptionsListener implements IListener {
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('pricebookOptions');
      }
    });
  }
}

export class PricebookSelectionsListener implements IListener {
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('pricebookSelectionIds');
      }
    });
  }
}

export class OrgAvailablePricebooksListener implements IListener {
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('orgAvailablePricebooks');
      }
    });
  }
}

export class TeamAvailablePricebooksListener implements IListener {
  constructor(
    @injectSubject(Predicates.TeamSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('teamAvailablePricebooks');
      }
    });
  }
}

export class TeamPricebooksInUseListener implements IListener {
  constructor(
    @injectSubject(Predicates.TeamSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (!x) {
        this.cache.reset('teamPricebooksInUse');
      }
    });
  }
}

export class GroupAvailablePricebooksListener implements IListener {
  constructor(
    @injectDataCache(groupStorageKey)
    private readonly groupCache: DataCache<GroupCompartments>,
    @injectDataCache(pricebookStorageKey)
    private readonly cache: DataCache<PricebookCompartments>,
  ) {}

  start(): Subscription {
    return this.groupCache
      .observe$<GroupData | undefined>('group')
      .pipe(
        map(group => group?.id),
        distinctUntilChanged(),
        pairwise(),
      )
      .subscribe(([previousGroupId]) => {
        if (previousGroupId !== undefined) {
          this.cache.reset('groupAvailablePricebooks');
        }
      });
  }
}
